import React, { useState } from 'react'
import styled from 'styled-components'
import InputPassword from '../../shared/input/new/InputPassword'
import Btn from '../../shared/button/Btn'
import { useDispatch } from 'react-redux'
import { changePassoword } from "../../../features/companyProfile/companyProfileSlice"
import { changePassword } from '../../../features/companyProfile/companyAuthorizationSlice'

const Container = styled.div`
    width: calc(100% - 350px);
    height: 100%;
    p{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        margin-bottom: 20px;
    }
    .password-container{
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`

const ProfilSifreVeGuvenlikContainer = () => {
    const dispatch = useDispatch()
    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showNewPasswordRepeat, setShowNewPasswordRepeat] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [data, setData] = useState({
        password: "",
        newPassword: "",
        newPasswordRepeat: ""
    })

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = () => {
        setIsSubmitting(true)
        if(data.password && (data.newPassword === data.newPasswordRepeat)) {
            dispatch(changePassword({
                oldPassword: data.password,
                newPassword: data.newPassword
            }))
            setData({
                password: "",
                newPassword: "",
                newPasswordRepeat: ""
            })
        }
    }

  return (
    <Container>
        <p>Şifre Değiştirme</p>
        <div className="password-container">
            <InputPassword auto={"new-password"} data={data?.password} setData={(e) => handleChange(e)} labelText={"Eski Şifre"} name={"password"} inputWidth={"300px"} isShow={showOldPassword} showPassword={() => setShowOldPassword(!showOldPassword)} type={showOldPassword ? "text" : "password"} />
            <InputPassword auto={"new-password"} data={data?.newPassword} setData={(e) => handleChange(e)} labelText={"Yeni Şifre"} name={"newPassword"} inputWidth={"300px"} isShow={showNewPassword} showPassword={() => setShowNewPassword(!showNewPassword)} type={showNewPassword ? "text" : "password"} />
            <InputPassword auto={"new-password"} data={data?.newPasswordRepeat} setData={(e) => handleChange(e)} labelText={"Yeni Şifre Tekrar"} name={"newPasswordRepeat"} inputWidth={"300px"} isShow={showNewPasswordRepeat} showPassword={() => setShowNewPasswordRepeat(!showNewPasswordRepeat)} type={showNewPasswordRepeat ? "text" : "password"} />
            {
                isSubmitting && (data.newPassword !== data.newPasswordRepeat) && <p style={{color: "#E85446", fontSize: "14px", fontWeight: "500", marginBottom: "0px"}}>Yeni şifreler eşleşmiyor</p>
            }
            <Btn width={"300px"} bgColor="transparent" color="#E85446" handleClick={handleSubmit} >Değiştir</Btn>
        </div>
    </Container>
  )
}

export default ProfilSifreVeGuvenlikContainer